import React, { useEffect, useState } from "react";
import { useStores } from "#stores";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

export function formatLanguageToBeamer(language: string) {
	switch (language) {
		case "en-US":
			return "EN";
		case "es-ES":
			return "ES";
		case "fr-FR":
			return "FR";
		case "pt-BR":
		default:
			return "PT";
	}
}

function useBeamerPath() {
	const [isBeamerPath, setIsBeamerPath] = useState(false);

	useEffect(() => {
		const pathsToShowBeamer = ["^\\/$", "^\\/place\\/[^\\/]+$"];

		const isBeamerPath = pathsToShowBeamer.some(path =>
			new RegExp(path).test(window.location.pathname),
		);

		setIsBeamerPath(isBeamerPath);
	}, [window.location.pathname]);

	return isBeamerPath;
}

function useBeamerAvailability() {
	const [isBeamerAvailable, setIsBeamerAvailable] = useState(false);

	useEffect(() => {
		if (window.Beamer) {
			setIsBeamerAvailable(true);
			return;
		}

		const observer = new MutationObserver(() => {
			if (window.Beamer) {
				setIsBeamerAvailable(true);
				observer.disconnect();
			}
		});

		observer.observe(document.head, {
			childList: true,
			subtree: true,
		});

		return () => observer.disconnect();
	}, []);

	return isBeamerAvailable;
}

export function BeamerEmbedIntegration() {
	const { authStore } = useStores();
	const { i18n } = useTranslation();

	const isBeamerPath = useBeamerPath();
	const isBeamerAvailable = useBeamerAvailability();

	useEffect(() => {
		if (!isBeamerPath) {
			if (isBeamerAvailable) {
				window.Beamer.destroy();
			}
			return;
		}

		if (isBeamerAvailable) {
			window.Beamer.init();
		}

		return () => {
			if (isBeamerAvailable) {
				window.Beamer.destroy();
			}
		};
	}, [isBeamerPath, isBeamerAvailable]);

	if (!authStore.currentEmployee) return null;

	const language = formatLanguageToBeamer(i18n.language);
	const nameParts = authStore.currentEmployee.name.split(" ");
	const firstName = nameParts.length > 0 ? nameParts[0] : undefined;
	const lastName = nameParts.length > 1 ? nameParts[nameParts.length - 1] : undefined;

	const beamerConfig: typeof window.beamer_config = {
		product_id: "jPGbZfol71901",
		language: language,
		lazy: true,
		user_email: authStore.currentEmployee.username,
		user_id: authStore.currentEmployee.id,
		user_firstname: firstName,
		user_lastname: lastName,
	};

	return (
		<Helmet>
			<script>
				{`
					var beamer_config = ${JSON.stringify(beamerConfig)};
				`}
			</script>
			{/* @ts-ignore */}
			<script src="https://app.getbeamer.com/js/beamer-embed.js" defer="defer"></script>
		</Helmet>
	);
}
